import {
    Dumbbell, Activity, Zap, PersonStanding, Bike, Mountain, Heart, Flag,
    Footprints, Waves, Snowflake, Music, Wind, Trophy, Target, Sparkles
} from 'lucide-react';

// 50+ workout types organized by category
// MET values must match /app/backend/routers/fitness.py MET_VALUES
export const WORKOUT_CATEGORIES = {
    de: {
        strength: 'Kraft',
        cardio: 'Cardio',
        racquet: 'Schläger',
        combat: 'Kampfsport',
        mind: 'Mind & Body',
        outdoor: 'Outdoor',
        team: 'Mannschaft',
        other: 'Sonstiges',
    },
    en: {
        strength: 'Strength',
        cardio: 'Cardio',
        racquet: 'Racquet',
        combat: 'Combat',
        mind: 'Mind & Body',
        outdoor: 'Outdoor',
        team: 'Team',
        other: 'Other',
    },
};

export const WORKOUT_TYPES = [
    // ===== Strength =====
    { value: 'strength', category: 'strength', label: { de: 'Krafttraining', en: 'Strength' }, icon: Dumbbell, color: '#ef4444' },
    { value: 'crossfit', category: 'strength', label: { de: 'CrossFit', en: 'CrossFit' }, icon: Dumbbell, color: '#dc2626' },
    { value: 'bodyweight', category: 'strength', label: { de: 'Bodyweight', en: 'Bodyweight' }, icon: PersonStanding, color: '#f43f5e' },
    { value: 'calisthenics', category: 'strength', label: { de: 'Calisthenics', en: 'Calisthenics' }, icon: PersonStanding, color: '#e11d48' },
    { value: 'kettlebell', category: 'strength', label: { de: 'Kettlebell', en: 'Kettlebell' }, icon: Dumbbell, color: '#be123c' },
    { value: 'powerlifting', category: 'strength', label: { de: 'Powerlifting', en: 'Powerlifting' }, icon: Dumbbell, color: '#9f1239' },

    // ===== Cardio =====
    { value: 'running', category: 'cardio', label: { de: 'Laufen', en: 'Running' }, icon: Activity, color: '#3b82f6' },
    { value: 'trail_running', category: 'cardio', label: { de: 'Trail Running', en: 'Trail Running' }, icon: Mountain, color: '#2563eb' },
    { value: 'cardio', category: 'cardio', label: { de: 'Cardio', en: 'Cardio' }, icon: Activity, color: '#1d4ed8' },
    { value: 'hiit', category: 'cardio', label: { de: 'HIIT', en: 'HIIT' }, icon: Zap, color: '#f97316' },
    { value: 'cycling', category: 'cardio', label: { de: 'Radfahren', en: 'Cycling' }, icon: Bike, color: '#22c55e' },
    { value: 'mountain_biking', category: 'cardio', label: { de: 'Mountainbike', en: 'Mountain Biking' }, icon: Bike, color: '#16a34a' },
    { value: 'spinning', category: 'cardio', label: { de: 'Spinning', en: 'Spinning' }, icon: Bike, color: '#15803d' },
    { value: 'ebike', category: 'cardio', label: { de: 'E-Bike', en: 'E-Bike' }, icon: Bike, color: '#65a30d' },
    { value: 'walking', category: 'cardio', label: { de: 'Spazieren', en: 'Walking' }, icon: Footprints, color: '#84cc16' },
    { value: 'treadmill', category: 'cardio', label: { de: 'Laufband', en: 'Treadmill' }, icon: Activity, color: '#0ea5e9' },
    { value: 'elliptical', category: 'cardio', label: { de: 'Crosstrainer', en: 'Elliptical' }, icon: Activity, color: '#06b6d4' },
    { value: 'rowing', category: 'cardio', label: { de: 'Rudern', en: 'Rowing' }, icon: Waves, color: '#0891b2' },
    { value: 'stair_climbing', category: 'cardio', label: { de: 'Stepper', en: 'Stair Climbing' }, icon: Mountain, color: '#0e7490' },
    { value: 'jump_rope', category: 'cardio', label: { de: 'Seilspringen', en: 'Jump Rope' }, icon: Zap, color: '#ea580c' },

    // ===== Racquet =====
    { value: 'tennis', category: 'racquet', label: { de: 'Tennis', en: 'Tennis' }, icon: Target, color: '#facc15' },
    { value: 'badminton', category: 'racquet', label: { de: 'Badminton', en: 'Badminton' }, icon: Target, color: '#eab308' },
    { value: 'squash', category: 'racquet', label: { de: 'Squash', en: 'Squash' }, icon: Target, color: '#ca8a04' },
    { value: 'table_tennis', category: 'racquet', label: { de: 'Tischtennis', en: 'Table Tennis' }, icon: Target, color: '#a16207' },
    { value: 'padel', category: 'racquet', label: { de: 'Padel', en: 'Padel' }, icon: Target, color: '#854d0e' },

    // ===== Combat =====
    { value: 'boxing', category: 'combat', label: { de: 'Boxen', en: 'Boxing' }, icon: Trophy, color: '#dc2626' },
    { value: 'kickboxing', category: 'combat', label: { de: 'Kickboxen', en: 'Kickboxing' }, icon: Trophy, color: '#b91c1c' },
    { value: 'martial_arts', category: 'combat', label: { de: 'Kampfsport', en: 'Martial Arts' }, icon: Trophy, color: '#991b1b' },
    { value: 'mma', category: 'combat', label: { de: 'MMA', en: 'MMA' }, icon: Trophy, color: '#7f1d1d' },

    // ===== Mind & Body =====
    { value: 'yoga', category: 'mind', label: { de: 'Yoga', en: 'Yoga' }, icon: PersonStanding, color: '#8b5cf6' },
    { value: 'pilates', category: 'mind', label: { de: 'Pilates', en: 'Pilates' }, icon: PersonStanding, color: '#7c3aed' },
    { value: 'stretching', category: 'mind', label: { de: 'Stretching', en: 'Stretching' }, icon: PersonStanding, color: '#a855f7' },
    { value: 'tai_chi', category: 'mind', label: { de: 'Tai Chi', en: 'Tai Chi' }, icon: Wind, color: '#9333ea' },
    { value: 'meditation', category: 'mind', label: { de: 'Meditation', en: 'Meditation' }, icon: Sparkles, color: '#6b21a8' },
    { value: 'dancing', category: 'mind', label: { de: 'Tanzen', en: 'Dancing' }, icon: Music, color: '#ec4899' },
    { value: 'zumba', category: 'mind', label: { de: 'Zumba', en: 'Zumba' }, icon: Music, color: '#db2777' },
    { value: 'aerobics', category: 'mind', label: { de: 'Aerobic', en: 'Aerobics' }, icon: Music, color: '#be185d' },

    // ===== Outdoor / Adventure =====
    { value: 'swimming', category: 'outdoor', label: { de: 'Schwimmen', en: 'Swimming' }, icon: Waves, color: '#06b6d4' },
    { value: 'hiking', category: 'outdoor', label: { de: 'Wandern', en: 'Hiking' }, icon: Mountain, color: '#059669' },
    { value: 'climbing', category: 'outdoor', label: { de: 'Klettern', en: 'Climbing' }, icon: Mountain, color: '#047857' },
    { value: 'bouldering', category: 'outdoor', label: { de: 'Bouldern', en: 'Bouldering' }, icon: Mountain, color: '#065f46' },
    { value: 'skiing', category: 'outdoor', label: { de: 'Skifahren', en: 'Skiing' }, icon: Snowflake, color: '#38bdf8' },
    { value: 'snowboarding', category: 'outdoor', label: { de: 'Snowboard', en: 'Snowboarding' }, icon: Snowflake, color: '#0ea5e9' },
    { value: 'ice_skating', category: 'outdoor', label: { de: 'Schlittschuh', en: 'Ice Skating' }, icon: Snowflake, color: '#7dd3fc' },
    { value: 'kayaking', category: 'outdoor', label: { de: 'Kajak', en: 'Kayaking' }, icon: Waves, color: '#0284c7' },
    { value: 'sup', category: 'outdoor', label: { de: 'SUP', en: 'SUP' }, icon: Waves, color: '#0369a1' },
    { value: 'surfing', category: 'outdoor', label: { de: 'Surfen', en: 'Surfing' }, icon: Waves, color: '#075985' },
    { value: 'skateboarding', category: 'outdoor', label: { de: 'Skateboard', en: 'Skateboarding' }, icon: Activity, color: '#525252' },
    { value: 'horseback_riding', category: 'outdoor', label: { de: 'Reiten', en: 'Horseback Riding' }, icon: Heart, color: '#92400e' },
    { value: 'golf', category: 'outdoor', label: { de: 'Golf', en: 'Golf' }, icon: Flag, color: '#16a34a' },

    // ===== Team Sports =====
    { value: 'soccer', category: 'team', label: { de: 'Fußball', en: 'Soccer' }, icon: Trophy, color: '#22c55e' },
    { value: 'basketball', category: 'team', label: { de: 'Basketball', en: 'Basketball' }, icon: Trophy, color: '#ea580c' },
    { value: 'volleyball', category: 'team', label: { de: 'Volleyball', en: 'Volleyball' }, icon: Trophy, color: '#f59e0b' },
    { value: 'handball', category: 'team', label: { de: 'Handball', en: 'Handball' }, icon: Trophy, color: '#d97706' },
    { value: 'hockey', category: 'team', label: { de: 'Hockey', en: 'Hockey' }, icon: Trophy, color: '#0369a1' },
    { value: 'baseball', category: 'team', label: { de: 'Baseball', en: 'Baseball' }, icon: Trophy, color: '#3f3f46' },

    // ===== Other =====
    { value: 'other', category: 'other', label: { de: 'Sonstiges', en: 'Other' }, icon: Heart, color: '#6b7280' },
];

export const getWorkoutType = (value) =>
    WORKOUT_TYPES.find((w) => w.value === value) || WORKOUT_TYPES[WORKOUT_TYPES.length - 1];
